import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Environment } from '../../utils/environment.util';

/**
 * Secciones en pruebas (Ventas y Marketing): se ven en local y en staging, pero
 * no en producción hasta que el negocio las libere. Es el único punto que lo
 * decide; el release oficial borra este archivo y sus usos.
 *
 * @returns true fuera de producción
 */
export const isPreReleaseVisible = (): boolean => !Environment.isProduction;

/**
 * Guard de las rutas en pruebas. En producción manda a Inicio, como
 * `permissionGuard` con un usuario sin permiso, para que un enlace directo
 * tampoco abra la pantalla.
 */
export const preReleaseGuard: CanActivateFn = () =>
  isPreReleaseVisible() || inject(Router).createUrlTree(['/home']);
